<template>
  <!--合作伙伴-->
  <section id="partner">
    <div class="caption">
      <h1>合作伙伴</h1>
      <div class="caption-sub middle">
        <div class="flex"></div>
        <span>PARTNERS</span>
        <div class="flex"></div>
      </div>
    </div>

    <div class="partner" ref="partner">
      <div class="item">
        <img src="@/assets/images/index/partners/1.png" alt="" />
      </div>
      <div class="item">
        <img src="@/assets/images/index/partners/2.png" alt="" />
      </div>
      <div class="item">
        <img src="@/assets/images/index/partners/3.png" alt="" />
      </div>
      <div class="item">
        <img src="@/assets/images/index/partners/4.png" alt="" />
      </div>
      <div class="item">
        <img src="@/assets/images/index/partners/5.png" alt="" />
      </div>
      <div class="item">
        <img src="@/assets/images/index/partners/6.png" alt="" />
      </div>
      <div class="item">
        <img src="@/assets/images/index/partners/7.png" alt="" />
      </div>
      <div class="item">
        <img src="@/assets/images/index/partners/8.png" alt="" />
      </div>
      <div class="item">
        <img src="@/assets/images/index/partners/9.png" alt="" />
      </div>
      <div class="item">
        <img src="@/assets/images/index/partners/10.png" alt="" />
      </div>
      <div class="item">
        <img src="@/assets/images/index/partners/11.png" alt="" />
      </div>
      <div class="item">
        <img src="@/assets/images/index/partners/12.png" alt="" />
      </div>
      <!-- <div class="item"><img src="@/assets/images/index/partners/13.png" alt=""></div>
      <div class="item"><img src="@/assets/images/index/partners/14.png" alt=""></div>
      <div class="item"><img src="@/assets/images/index/partners/15.png" alt=""></div>
      <div class="item"><img src="@/assets/images/index/partners/16.png" alt=""></div> -->
    </div>
  </section>
</template>

<script>
import play from "./play";

export default {
  mounted() {
    play([this.$refs.partner], "anm-fadeIn");
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/common.scss";

section#partner {
  display: flex;
  flex-direction: column;
  align-items: center;

  > .partner {
    display: flex;
    flex-wrap: wrap;

    width: $SIZE_PAGE_WIDTH;
    margin-bottom: 20px;

    > .item {
      width: $SIZE_PAGE_WIDTH / 4;
      height: 15vh;
      // text-align: center;
      display: flex;
      justify-content: center;
      align-items: center;

      > img {
        max-width: 300px;
        max-height: 100px;
      }
    }
  }

  .anm-fadeIn {
    animation: fadeIn 3s;
  }
}
</style>